module.exports = __webpack_public_path__ + "assets/img/1-2.ac296ee4.png";